var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Breadcrumb',{attrs:{"getNav":_vm.getNav,"info":'产品详情'}}),_c('el-card',[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"产品信息与手册"}},[_c('RecipeList'),_c('Recipes',{attrs:{"info":_vm.info}})],1),_c('el-tab-pane',{attrs:{"label":"产品说明"}},[_c('Procedure',{attrs:{"info":_vm.info}})],1)],1),_c('div',{staticStyle:{"height":"2px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }